import React from 'react';
import { StarIcon, PlayIcon, LightbulbIcon, Share2Icon, HeartIcon, MessageCircleIcon, CheckIcon } from 'lucide-react';
export function TemplateFormLongPage() {
  return <div className="min-h-screen w-full bg-[#f8f7f4] font-sans text-[#1e293b] selection:bg-[#b91c1c] selection:text-white" data-id="element-1639">
      {/* 1. Top Nav Bar - 3 Column Layout */}
      <header className="bg-[#002868] text-white w-full py-3" data-id="element-1640">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-row items-center justify-between gap-2 sm:gap-4" data-id="element-1641">
          {/* Left: Logo */}
          <div className="flex items-center gap-1.5 sm:gap-2 font-bold text-base sm:text-xl tracking-tight" data-id="element-1642">
            <StarIcon className="w-5 h-5 sm:w-6 sm:h-6 fill-current text-[#b91c1c]" data-id="element-1643" />
            <span data-id="element-1644">PatriotsInformer News</span>
          </div>

          {/* Right: Get Started Button */}
          <div className="flex-shrink-0" data-id="element-1645">
            <button className="px-3 sm:px-4 py-1.5 border border-white rounded text-xs sm:text-sm font-semibold hover:bg-white hover:text-[#002868] transition-colors whitespace-nowrap" data-id="element-1646">
              Get Started »
            </button>
          </div>
        </div>
      </header>

      {/* Main Content Container */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-id="element-1647">
        {/* 2. Author Bio Section */}
        <div className="flex flex-row items-center gap-4 sm:gap-6 max-w-3xl mx-auto mb-12" data-id="element-1648">
          <img src="https://cdn.magicpatterns.com/uploads/qCiNdfGtT6ARUfiGnS7VJm/jack-turner-avatar-2.jpg" alt="Author" className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover border-2 border-gray-200 shadow-sm flex-shrink-0" data-id="element-1649" />
          <div className="text-left space-y-1" data-id="element-1650">
            <h3 className="font-bold text-[#0f172a] text-lg" data-id="element-1651">Jack Turner</h3>
            <p className="text-gray-500 text-sm" data-id="element-1652">
              Head of research at PatriotsInformer.com
            </p>
            <p className="text-gray-400 text-xs uppercase tracking-wide pt-1" data-id="element-1653">
              September 24, 2025 · 4 min read
            </p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 relative" data-id="element-1654">
          {/* 1. Social Share Sidebar (Desktop Sticky) */}
          <aside className="hidden lg:flex flex-col gap-6 sticky top-8 h-fit w-16 items-center pt-8 text-gray-400" data-id="element-1655">
            <div className="flex flex-col items-center gap-1 cursor-pointer hover:text-[#b91c1c] transition-colors group" data-id="element-1656">
              <div className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center bg-white shadow-sm group-hover:border-[#b91c1c]" data-id="element-1657">
                <Share2Icon className="w-5 h-5" data-id="element-1658" />
              </div>
              <span className="text-xs font-medium" data-id="element-1659">Share</span>
            </div>
            <div className="flex flex-col items-center gap-1 cursor-pointer hover:text-[#b91c1c] transition-colors group" data-id="element-1660">
              <div className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center bg-white shadow-sm group-hover:border-[#b91c1c]" data-id="element-1661">
                <HeartIcon className="w-5 h-5" data-id="element-1662" />
              </div>
              <span className="text-xs font-medium" data-id="element-1663">124</span>
            </div>
            <div className="flex flex-col items-center gap-1 cursor-pointer hover:text-[#b91c1c] transition-colors group" data-id="element-1664">
              <div className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center bg-white shadow-sm group-hover:border-[#b91c1c]" data-id="element-1665">
                <MessageCircleIcon className="w-5 h-5" data-id="element-1666" />
              </div>
              <span className="text-xs font-medium" data-id="element-1667">42</span>
            </div>
          </aside>

          {/* Main Article Content */}
          <article className="flex-1 max-w-3xl mx-auto space-y-10" data-id="element-1668">
            {/* Headline & Subtitle */}
            <div className="space-y-6 text-center sm:text-left" data-id="element-1669">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0f172a] tracking-tight leading-tight" data-id="element-1670">
                How to Secure Your Water Supply Fast WITHOUT Drilling a Single
                Well!
              </h1>
              <div className="space-y-4" data-id="element-1671">
                <p className="text-xl sm:text-2xl text-gray-500 font-light leading-relaxed" data-id="element-1672">
                  This works even if your property is BRAND NEW!
                </p>
                <p className="text-xl sm:text-2xl text-gray-500 font-light leading-relaxed" style={{
                marginTop: '0px'
              }} data-id="element-1673">
                  Watch the video now...
                </p>
              </div>
            </div>

            {/* Video Placeholder */}
            <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden shadow-xl group cursor-pointer" data-id="element-1674">
              <img src="https://images.unsplash.com/photo-1538300342682-cf57afb97285?q=80&w=2574&auto=format&fit=crop" alt="Video thumbnail" className="w-full h-full object-cover opacity-80 group-hover:opacity-60 transition-opacity" data-id="element-1675" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-1676">
                <div className="w-20 h-20 bg-[#b91c1c] rounded-xl flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300" data-id="element-1677">
                  <PlayIcon className="w-10 h-10 text-white fill-current ml-1" data-id="element-1678" />
                </div>
              </div>
              <div className="absolute bottom-4 left-4 bg-black/70 px-3 py-1 rounded text-white text-sm font-medium flex items-center gap-2" data-id="element-1679">
                <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-1680"></span>
                Watch Now
              </div>
            </div>

            {/* 2. Opening Paragraphs */}
            <div className="space-y-6 text-lg text-[#334155] leading-relaxed" data-id="element-1681">
              <p className="font-medium text-[#0f172a]" data-id="element-1682">
                Alright, let's get right to it here...
              </p>
              <p data-id="element-1683">
                As you saw in the video, you now know how you can secure 100% of
                your family's water needs without drilling a single well
                yourself... and without waiting 6-12 months for a drilling
                company to show up. This is the fastest way to get a reliable,
                off-grid water source off the ground—hands down.
              </p>
              <p className="italic font-medium text-[#0f172a]" data-id="element-1684">
                And the best part?
              </p>
              <p data-id="element-1685">
                It works straight from any rain barrel, nearby creek, or even a
                murky pond—the original survival water source.
              </p>
              <p data-id="element-1686">Let's recap...</p>
            </div>

            {/* 3. Section Heading */}
            <div className="space-y-6" data-id="element-1687">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#0f172a] text-center" data-id="element-1688">
                It All Starts With a Simple Filtration System...
              </h2>
              <div className="space-y-6 text-lg text-[#334155] leading-relaxed" data-id="element-1689">
                <p data-id="element-1690">
                  We call our special DIY Bio-Filter the{' '}
                  <span className="font-bold text-[#b91c1c]" data-id="element-1691">
                    "Endless Spring"
                  </span>{' '}
                  because it delivers pure water day after day, just like a
                  natural spring.
                </p>
                <p data-id="element-1692">
                  They showed us in four big buckets delivered right to his door
                  by UPS. Each bucket had the layers of sand and gravel, and he
                  paid about $15 per bucket, shipping included.
                </p>
                <p className="font-bold text-[#0f172a]" data-id="element-1693">
                  Let me say that again.
                  <br data-id="element-1694" />
                  $15 per bucket.
                  <br data-id="element-1695" />
                  That's wild!
                </p>
                <p data-id="element-1696">
                  They were grown in a stack of common 5-gallon buckets you can
                  get at any hardware store. But come SHTF, when the taps run
                  dry... they'll turn that "dirty" water into a lifesaver.
                </p>
              </div>
            </div>

            {/* 4. CTA Callout Box */}
            <div className="border-4 border-dashed border-[#b91c1c] bg-yellow-50 p-6 sm:p-8 rounded-lg relative" data-id="element-1697">
              <div className="space-y-4" data-id="element-1698">
                <div className="flex items-start gap-3" data-id="element-1699">
                  <LightbulbIcon className="w-6 h-6 text-yellow-600 fill-current flex-shrink-0 mt-1" data-id="element-1700" />
                  <h3 className="text-xl font-bold text-[#0f172a]" data-id="element-1701">
                    Wanna know exactly where we get these materials for dirt
                    cheap?
                  </h3>
                </div>

                <p className="text-[#334155] text-lg leading-relaxed pl-9" style={{
                paddingLeft: '5px'
              }} data-id="element-1702">
                  We've packed all of our best sourcing secrets—including the
                  exact sand grades and gravel types—inside our DIY Biosand
                  System guide.
                </p>

                <div className="pl-9 pt-2" style={{
                paddingLeft: '5px'
              }} data-id="element-1703">
                  <a href="#" className="inline-flex items-center gap-2 text-[#002868] font-bold text-xl hover:underline decoration-2 underline-offset-4" data-id="element-1704">
                    Click here to learn more »
                  </a>
                </div>
              </div>
            </div>

            {/* 5. Divider */}
            <hr className="border-t-2 border-[#b91c1c] opacity-20 my-8" data-id="element-1705" />

            {/* 6. The Numbers Section */}
            <div className="space-y-6" data-id="element-1706">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#0f172a] text-center" data-id="element-1707">
                The Numbers That Make This Work
              </h2>
              <div className="space-y-6 text-lg text-[#334155] leading-relaxed" data-id="element-1708">
                <p data-id="element-1709">Let's say you only build 2 filters, just to start small.</p>
                <ul className="list-disc pl-6 space-y-2 marker:text-[#b91c1c]" data-id="element-1710">
                  <li data-id="element-1711">Your cost? 2 buckets x $15 = $30</li>
                  <li data-id="element-1712">Output? 40 gallons of clean water per day.</li>
                  <li data-id="element-1713">That's 1200 gallons a month from a $30 investment.</li>
                  <li data-id="element-1714">
                    Do it five times... and you've turned $150 into a community
                    water hub.
                  </li>
                </ul>
                <p className="font-bold text-[#0f172a]" data-id="element-1715">
                  That's a massive return on investment, and you didn't drill a
                  single hole yourself.
                </p>
                <p data-id="element-1716">
                  And if you've got ambitious neighbors?
                  <br data-id="element-1717" />
                  Let them use it for a small barter fee.
                  <br data-id="element-1718" />
                  Wait two years and you're looking at serious trading power.
                </p>
                <p className="italic" data-id="element-1719">
                  This is how backyard fortunes quietly stack serious profits.
                </p>
              </div>
            </div>

            {/* 7. Special Equipment Section */}
            <div className="space-y-6" data-id="element-1720">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#0f172a] text-center" data-id="element-1721">
                You Don't Need Special Equipment
              </h2>
              <div className="space-y-6 text-lg text-[#334155] leading-relaxed" data-id="element-1722">
                <p data-id="element-1723">
                  My dad told me about a customer of his who lives in a mobile
                  home park. She doesn't have a ton of space, but she's having
                  the time of her life purifying water for her garden. It's
                  right on her porch, and when people find out she has "magic
                  water"... they can't stop showing up.
                </p>
                <p className="italic font-medium text-[#0f172a]" data-id="element-1724">
                  People NEED clean water.
                </p>
                <p data-id="element-1725">
                  And when you've got something reliable, like these filters...
                  they basically sell themselves.
                </p>
                <p data-id="element-1726">
                  He even said his doctor started grilling him about what he
                  drinks when she saw his bloodwork. That's the kind of interest
                  you'll get just by mentioning what you do.
                </p>
              </div>
            </div>

            {/* 8. Bonus Tip Callout - Matching CTA Callout Box Style */}
            <div className="border-4 border-dashed border-[#b91c1c] bg-yellow-50 p-6 sm:p-8 rounded-lg relative" data-id="element-1727">
              <div className="space-y-4" data-id="element-1728">
                <div className="flex items-start gap-3" data-id="element-1729">
                  <h3 className="text-xl font-bold text-[#0f172a]" data-id="element-1730">
                    <span data-id="element-1731">🎁</span> Bonus Tip:
                  </h3>
                </div>

                <p className="text-[#334155] text-lg leading-relaxed pl-9" style={{
                paddingLeft: '5px'
              }} data-id="element-1732">
                  If you want to skip the years of trial and error—and get the
                  full blueprint for starting a profitable water setup—we've got
                  you covered.
                </p>
                <p className="text-[#334155] text-lg leading-relaxed pl-9" style={{
                paddingLeft: '5px'
              }} data-id="element-1733">
                  Our <span className="font-bold" data-id="element-1734">Backyard Growing System</span>{' '}
                  walks you through the entire process AND includes our{' '}
                  <span className="font-bold" data-id="element-1735">Secret Wholesale Directory</span>{' '}
                  with all our best sources for starter parts, tanks, and
                  valves.
                </p>
                <p className="italic text-sm text-gray-500 pl-9" style={{
                paddingLeft: '5px'
              }} data-id="element-1736">
                  "These aren't public hardware catalogs... these are
                  underground growers only realize we've built over decades."
                </p>

                <div className="pl-9 pt-2" style={{
                paddingLeft: '5px'
              }} data-id="element-1737">
                  <a href="#" className="inline-flex items-center gap-2 text-[#002868] font-bold text-xl hover:underline decoration-2 underline-offset-4" data-id="element-1738">
                    <span className="text-2xl" data-id="element-1739">👉</span>
                    Check it out here before prices go up »
                  </a>
                </div>
              </div>
            </div>

            {/* 9. Why This Works Section */}
            <div className="space-y-6" data-id="element-1740">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#0f172a] text-center" data-id="element-1741">
                Here's Why This Works So Well:
              </h2>
              <ol className="space-y-6 text-lg text-[#334155] leading-relaxed list-decimal pl-6 marker:text-[#b91c1c] marker:font-bold" data-id="element-1742">
                <li data-id="element-1743">
                  <span className="font-bold text-[#0f172a]" data-id="element-1744">
                    You're not starting from scratch
                  </span>{' '}
                  — you're skipping YEARS of guessing time and jumping straight
                  to profit.
                </li>
                <li data-id="element-1745">
                  <span className="font-bold text-[#0f172a]" data-id="element-1746">
                    You're not babysitting fragile systems
                  </span>{' '}
                  — these come with good biological layers and don't even know
                  they've been moved when you put them up.
                </li>
                <li data-id="element-1747">
                  <span className="font-bold text-[#0f172a]" data-id="element-1748">
                    You don't need acres
                  </span>{' '}
                  — you could start with 25 or 50 buckets tucked behind your
                  garage or patio.
                </li>
                <li data-id="element-1749">
                  <span className="font-bold text-[#0f172a]" data-id="element-1750">
                    Water doesn't sit around long
                  </span>{' '}
                  — as soon as people know you've got something good, they want
                  it.
                </li>
              </ol>
            </div>

            {/* 10. What to Do Next Section */}
            <div className="space-y-8" data-id="element-1751">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#0f172a] text-center" data-id="element-1752">
                What to Do Next
              </h2>
              <div className="space-y-6 text-lg text-[#334155] leading-relaxed" data-id="element-1753">
                <p data-id="element-1754">
                  If you want to try this for yourself, here's what I recommend:
                </p>
                <ul className="space-y-3 pl-6" data-id="element-1755">
                  <li className="flex items-start gap-3" data-id="element-1756">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#b91c1c] flex-shrink-0" data-id="element-1757" />
                    <span data-id="element-1758">Start small. 2-5 buckets is plenty.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1759">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#b91c1c] flex-shrink-0" data-id="element-1760" />
                    <span data-id="element-1761">
                      Pot them up or put them in a shed about 4 inches apart.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1762">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#b91c1c] flex-shrink-0" data-id="element-1763" />
                    <span data-id="element-1764">
                      Share pics of your setup online or with local prepper
                      groups.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1765">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#b91c1c] flex-shrink-0" data-id="element-1766" />
                    <span data-id="element-1767">Watch how fast they go.</span>
                  </li>
                </ul>
                <p data-id="element-1768">
                  And like I said... if you want a reliable place to get started
                  cheap...
                  <br data-id="element-1769" />
                  We've already done the hard work for you &nbsp;
                  <a href="#" className="text-[#002868] font-bold underline hover:text-[#b91c1c]" data-id="element-1770">
                    click here for instant access.
                  </a>
                </p>
                <p data-id="element-1771">
                  This is hands-down one of the easiest ways to get into the
                  backyard survival game, and it's crazy profitable if you stick
                  with it.
                </p>

                <div className="pt-8 space-y-2" data-id="element-1772">
                  <p className="text-lg font-medium text-[#0f172a]" data-id="element-1773">
                    Learn. Build. Be ready.
                  </p>
                  <img src="https://cdn.magicpatterns.com/uploads/iK7Ls4uTvRReaehp29Hcev/JackTurnerSigntature.png" alt="Jack Turner Signature" className="h-28 py-2" data-id="element-1774" />
                  <p className="text-sm font-bold text-[#0f172a] uppercase tracking-wide" data-id="element-1775">
                    Jack Turner
                  </p>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>

      {/* Footer - Reusing style */}
      <footer className="bg-white border-t border-gray-200 mt-12 py-12" data-id="element-1776">
        <div className="max-w-4xl mx-auto px-4 text-center space-y-6" data-id="element-1777">
          <div className="flex items-center justify-center gap-2 text-[#b91c1c]" data-id="element-1778">
            {/* Simple Logo Graphic */}
            <div className="relative w-10 h-10" data-id="element-1779">
              <StarIcon className="w-10 h-10 fill-current text-[#002868]" data-id="element-1780" />
              <StarIcon className="w-4 h-4 fill-current text-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-1781" />
            </div>
          </div>

          <div className="text-xs text-gray-500 space-y-4 max-w-2xl mx-auto leading-relaxed" data-id="element-1782">
            <p data-id="element-1783">
              © 2018-2026 PatriotsInformer Media, LLC | All Rights Reserved |
              10160 Highway 242 Ste 800 PMB 1089, Conroe, TX 77385
            </p>
            <p className="space-x-2" data-id="element-1784">
              <a href="#" className="underline hover:text-[#002868]" data-id="element-1785">
                Terms & Conditions
              </a>
              <span data-id="element-1786">|</span>
              <a href="#" className="underline hover:text-[#002868]" data-id="element-1787">
                Privacy Policy
              </a>
              <span data-id="element-1788">|</span>
              <a href="#" className="underline hover:text-[#002868]" data-id="element-1789">
                Contact Us
              </a>
            </p>
            <p data-id="element-1790">
              No part of this report may be reproduced or placed on any
              electronic medium without written permission from the publisher.
              Information contained herein is obtained from sources believed to
              be reliable, but its accuracy cannot be guaranteed.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}